import httpClient from 'shared/lib/httpClient';
import { parseDoctorList } from '../schemas/MasterDataSchema';

/**
 * Fetch doctor master-data list.
 *
 * @param {Object} params - { search, page, limit }
 * @param {AbortSignal} [signal]
 * @returns {Promise<{ data: DoctorItem[], meta: { page, total, limit } }>}
 */
export const getDoctorList = async (params, signal) => {
  const response = await httpClient.get('/doctors', { params, signal });
  return parseDoctorList(response?.data);
};

export default getDoctorList;
